

import Vue from 'vue'
import FastClick from 'fastclick'
import router from './router'
import App from './App'

import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import WechatPlugin from 'vux/src/plugins/wechat/index.js'
import DatetimePlugin from 'vux/src/plugins/datetime/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'


import store from './store'
import {
storage,
extractCodeWx,
extractCodeAli,
getEnvByUrl
} from './js/common'
import http from './js/http'
import api from './js/api'

import _ from 'lodash'
Vue.prototype._ = _


Vue.use(LoadingPlugin)
Vue.use(ToastPlugin)
Vue.use(ConfirmPlugin)
Vue.use(WechatPlugin)
Vue.use(DatetimePlugin)
Vue.use(AlertPlugin)
Vue.directive('transfer-dom', TransferDom)
Vue.component('x-dialog', XDialog)
Vue.component('datetime', Datetime)
Vue.component('group', Group)
Vue.component('x-input', XInput)
Vue.component('x-button', XButton)
Vue.component('cell', Cell)
Vue.component('popup-radio', PopupRadio)

import { Icon } from 'vant';
Vue.use(Icon);

FastClick.prototype.focus = function(targetElement) {
var length;
let agent = navigator.userAgent;
let deviceIsIOS = !!agent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);


if (deviceIsIOS && targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement
.type !== 'time' && targetElement.type !== 'month' && targetElement.type !== 'email') {
length = targetElement.value.length;
targetElement.setSelectionRange(length, length);
/*修复bug ios 11.3不弹出键盘，这里加上聚焦代码，让其强制聚焦弹出键盘*/
targetElement.focus();
} else {
targetElement.focus();
}
};
FastClick.attach(document.body)

Vue.config.productionTip = false


router.beforeEach((to, from, next) => {
console.log(window.location.href, "......../////////0000000000");
document.title = to.meta.title

if (store.state.Env.noEnv) {
let env = getEnvByUrl()

store.commit('initEnv', env)
}
if (process.env.NODE_ENV === 'development') {


storage.setSessionstorage('openid', 'ojKqu6IhC2R8FA3eXSHftJl_XKyA')


next() 
} else {

let openId = storage.getSessionstorage('openid') 
if (!openId) {

let code = ''
if (store.state.Env.env === 'ali') {
code = extractCodeAli(window.location.href)
}
if (store.state.Env.env === 'wx') {
code = extractCodeWx(window.location.href)
}
let code2openidApi = api['code2openidwx']
http.get(code2openidApi, {
code: code
})
.then(res => {
console.log('code2ope响应', res)
let data = res.data
console.log('code2openid响应', data)
if (data.status) {
if (store.state.Env.env === 'wx') {
storage.setSessionstorage('openid', data.data.openid)

}
if (store.state.Env.env === 'ali') {
let alipayJSON = data.data;



storage.setSessionstorage('openid', alipayJSON.user_id);
storage.setSessionstorage('token', alipayJSON.token);

storage.setSessionstorage('userName', alipayJSON.userName);
storage.setSessionstorage('userIdCard', alipayJSON.userIdCard);



}
next()
} else {
next(false)
Vue.$vux.toast.text('授权失败' + data.msg)
console.log('授权失败', data.msg)
}
})
} else {
next()
}
}
})

/* eslint-disable no-new */
new Vue({
router,
store,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js